import React from "react";
import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { aboutText } from "../../data/mock";

const AboutSection = () => {
  const description = typeof aboutText.description === "string"
    ? aboutText.description
    : "";
  const paragraphs = description.split("\n\n").filter(Boolean);

  return (
    <section className="py-24 bg-[#F6F7F1] relative overflow-hidden">
      <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-pink-50 -translate-y-1/2 translate-x-1/2" />
      <div className="absolute bottom-0 left-0 w-48 h-48 rounded-full bg-[#FFF8E1] translate-y-1/2 -translate-x-1/2" />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="h-px w-16 bg-[#D4AF37]" />
            <Sparkles className="w-5 h-5 text-[#D4AF37]" />
            <div className="h-px w-16 bg-[#D4AF37]" />
          </div>
          <h2 className="font-playfair text-3xl md:text-5xl font-bold text-gray-900 mb-8">
            {typeof aboutText.title === "string" ? aboutText.title : "Bienvenue"}
          </h2>
          <div className="max-w-3xl mx-auto">
            {paragraphs.map((paragraph, index) => (
              <p key={`about-paragraph-${index}`} className="text-gray-600 leading-relaxed mb-4 text-lg">
                {paragraph}
              </p>
            ))}
          </div>
          {typeof aboutText.cta === "string" && aboutText.cta && (
            <div className="mt-12">
              <p className="font-playfair text-2xl md:text-3xl text-[#E5007D] italic font-medium">
                {aboutText.cta}
              </p>
            </div>
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default AboutSection;
